import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { STUDENT_CONNECTION_FRAGMENT, LIMIT } from './constants';

const query = gql`
  mutation updateActiveMatchConnectionsLastDownloadedDatetime
      ($input: updateActiveMatchConnectionsLastDownloadedDatetimeInput!, $limit: Int, $page: Int) {
      updateActiveMatchConnectionsLastDownloadedDatetime (input: $input){
        viewer {
          id
          amStudentConnectionsSinceLastExport(page: $page, limit: $limit) {
            pagination {
              totalCount
            }
            results {
              ...AMStudentResults
            }
          }
          heAccount {
            id
            activeMatchConnectionsLastDownloadedDatetime
          }
        }
      }
    }
  ${STUDENT_CONNECTION_FRAGMENT}
`;

export const refetchQueries = () => ['AMPlusDownloadConnections'];
export default graphql(query, {
  name: 'updateLastDownloadTime',
  options: {
    variables: {
      input: {}, page: 1, limit: LIMIT,
    },
    refetchQueries,
  },
});
